"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixDisabledAttributeToPseudoStateInAst = exports.fixDisabledAttributeToPseudoStateInCss = void 0;
var postcss_1 = require("postcss");
// This css fixer is a fix (workaround) for https://jira.wixpress.com/browse/STYL-877
/** DISCLAIMER - this script does not support multiple selector inside rules and aim to fix stylable-editor output css only */
var fixDisabledAttributeToPseudoStateInCss = function (css) {
    if (css.includes('[disabled]')) {
        var ast = postcss_1.parse(css);
        fixDisabledAttributeToPseudoStateInAst(ast);
        return ast.toString();
    }
    else {
        return css;
    }
};
exports.fixDisabledAttributeToPseudoStateInCss = fixDisabledAttributeToPseudoStateInCss;
function fixDisabledAttributeToPseudoStateInAst(ast) {
    ast.walkRules(/\[disabled\]/, function (rule) {
        rule.selector = rule.selector.replace(/\[disabled\]/g, ':disabled');
    });
    var groups = {};
    ast.walkRules(/:disabled/, function (rule) {
        groups[rule.selector] = groups[rule.selector] || new Map();
        if (!rule.parent) {
            return;
        }
        var bucket = groups[rule.selector].get(rule.parent);
        if (!bucket) {
            groups[rule.selector].set(rule.parent, (bucket = []));
        }
        bucket.push(rule);
    });
    for (var _i = 0, _a = Object.values(groups); _i < _a.length; _i++) {
        var rulesByParent = _a[_i];
        rulesByParent.forEach(function (rules) { return mergeShallowRules(rules); });
    }
}
exports.fixDisabledAttributeToPseudoStateInAst = fixDisabledAttributeToPseudoStateInAst;
function mergeShallowRules(rules) {
    var decls = new Map();
    if (rules.length === 1) {
        return;
    }
    var lastRule = rules[0];
    for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];
        for (var _i = 0, _a = rule.nodes; _i < _a.length; _i++) {
            var decl = _a[_i];
            if (decl.type === 'decl') {
                if (decls.has(decl.prop)) {
                    decls.delete(decl.prop);
                }
                decls.set(decl.prop, decl);
            }
        }
        if (i !== rules.length - 1) {
            rule.remove();
        }
        lastRule = rule;
    }
    lastRule.nodes = Array.from(decls.values());
}
//# sourceMappingURL=fix-disabled-attribute.js.map